import { jsx as _jsx } from "react/jsx-runtime";
import { KioskIntegration } from '@inter-ikea-gallery/integration';
import { useEffect, useMemo } from 'react';
import { isPlatformIpexGallery } from '@inter-ikea-guida/utils';
import { KeyboardInjector } from '../components/kiosk/KeyboardInjector';
import { buildContext } from './buildContext';
export const [useKioskIntegration, KioskIntegrationContextProvider] = buildContext();
const USER_EVENTS = [
    'wheel',
    'mousedown',
    'touchstart',
    'touchmove',
    'MSPointerDown',
    'MSPointerMove',
    'onclick'
];
const startKioskIntegration = (kioskIntegration, platform) => {
    if (isPlatformIpexGallery(platform)) {
        // For ipex gallery, we use their built in idle timer and banner
        kioskIntegration.handleCountdownBanner();
    }
    kioskIntegration.applicationLoaded();
};
export const KioskIntegrationProvider = ({ kioskPlatform, keyboardInjector, children }) => {
    const kioskIntegration = useMemo(() => {
        if (!kioskPlatform) {
            return undefined;
        }
        return new KioskIntegration({ platform: kioskPlatform });
    }, [kioskPlatform]);
    if (kioskIntegration && kioskPlatform) {
        startKioskIntegration(kioskIntegration, kioskPlatform);
    }
    // Handle user interaction events
    useEffect(() => {
        if (!kioskIntegration) {
            return;
        }
        const onUserInteraction = () => {
            return kioskIntegration.userInteraction();
        };
        USER_EVENTS.forEach(event => {
            window.addEventListener(event, onUserInteraction);
        });
        return () => {
            USER_EVENTS.forEach(event => {
                window.removeEventListener(event, onUserInteraction);
            });
        };
    }, [kioskIntegration]);
    return (_jsx(KioskIntegrationContextProvider, { value: { kioskIntegration, kioskPlatform }, children: isPlatformIpexGallery(kioskPlatform) ? (_jsx(KeyboardInjector, { doneButtonLabel: keyboardInjector?.doneButtonLabel, children: children })) : (children) }));
};
//# sourceMappingURL=kioskIntegration.js.map